import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { ServiceResult } from '../types/common/ServiceResult';
import type { DistrictViewModel, DistrictCreateModel, DistrictUpdateModel } from '../types/district';
import { apiClient } from '../client/client';

export interface DistrictQuery {
  cityId?: number | null;
}

export class DistrictService {
  private static readonly BASE = '/api/district';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(query?: DistrictQuery): Promise<ServiceResultT<DistrictViewModel[]>> {
    const params: Record<string, number> = {};
    if (query?.cityId != null) params.CityId = query.cityId;
    const { data } = await this.client.get<ServiceResultT<DistrictViewModel[]>>(
      DistrictService.BASE,
      { params: Object.keys(params).length ? params : undefined }
    );
    return data;
  }

  async getById(id: number | string): Promise<ServiceResultT<DistrictViewModel>> {
    const { data } = await this.client.get<ServiceResultT<DistrictViewModel>>(
      `${DistrictService.BASE}/${id}`
    );
    return data;
  }

  async create(payload: DistrictCreateModel): Promise<ServiceResultT<DistrictViewModel>> {
    const { data } = await this.client.post<ServiceResultT<DistrictViewModel>>(
      DistrictService.BASE,
      payload
    );
    return data;
  }

  async update(id: number | string, payload: DistrictUpdateModel): Promise<ServiceResultT<DistrictViewModel>> {
    const { data } = await this.client.put<ServiceResultT<DistrictViewModel>>(
      `${DistrictService.BASE}/${id}`,
      payload
    );
    return data;
  }

  async delete(id: number | string): Promise<ServiceResult> {
    const { data } = await this.client.delete<ServiceResult>(`${DistrictService.BASE}/${id}`);
    return data;
  }
}

export const districtService = new DistrictService();
